
import React from 'react';
import Layout from '@/components/Layout';
import { CareBubbleVisual } from '@/components/CareBubble/CareBubbleVisual';
import BubbleMembers from '@/components/CareBubble/BubbleMembers';
import BubbleWallet from '@/components/CareBubble/BubbleWallet';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { motion } from 'framer-motion';

const CareBubble = () => {
  return (
    <Layout>
      <div className="container-custom pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-blue-800">Your BubbleCare Bubble</h1>
          <p className="text-muted-foreground mb-8">
            Manage your network of caregivers, family members, and volunteers
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
            <div className="lg:col-span-2">
              <CareBubbleVisual />
            </div>
            <div>
              <BubbleWallet />
            </div>
          </div>

          <Tabs defaultValue="members" className="w-full">
            <TabsList className="mb-6">
              <TabsTrigger value="members">Members</TabsTrigger>
              <TabsTrigger value="transactions">Transactions</TabsTrigger>
              <TabsTrigger value="settings">Settings</TabsTrigger>
            </TabsList>
            <TabsContent value="members">
              <BubbleMembers />
            </TabsContent>
            <TabsContent value="transactions">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="text-xl font-semibold mb-4">Recent Transactions</h3>
                <div className="text-muted-foreground text-center py-8">
                  No transactions yet
                </div>
              </div>
            </TabsContent>
            <TabsContent value="settings">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="text-xl font-semibold mb-4">Bubble Settings</h3>
                <p className="text-muted-foreground mb-4">
                  Configure your bubble settings and permissions
                </p>
                <div className="space-y-4">
                  {/* Settings options would go here */}
                  <div className="text-muted-foreground text-center py-8">
                    Coming soon
                  </div>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </motion.div>
      </div>
    </Layout>
  );
};

export default CareBubble;
